import React, { Component } from 'react'
import * as PIXI from 'pixi.js'
import './Animation.css'

export class Animation extends Component {
  constructor(props) {
    super(props)
    PIXI.SCALE_MODES.DEFAULT = PIXI.SCALE_MODES.NEAREST
    this.app = new PIXI.Application({
      transparent: true,
      width: window.innerWidth,
      height: window.innerHeight
    })
    this.app.view.style.position = 'relative'

    this.app.renderer.plugins.interaction.autoPreventDefault = false
    this.app.renderer.view.style.touchAction = 'auto'

    // this.app.view.style.width = window.innerWidth
    // this.app.view.style.height = window.innerHeight
    this.updateDimensions = this.updateDimensions.bind(this)
    this.animation = null
  }

  componentDidMount() {
    const frames = []
    this.pixiContainer.appendChild(this.app.view)

    this.isMobile = window.innerWidth < 800

    // Load the animation images
    for (let i = 1; i <= this.props.framesCount; i++) {
      this.app.loader.add(
        'frame' + i,
        require('./animations/' + this.props.name + '-' + i + '.svg')
      )
      frames.push()
    }
    this.app.loader.load((loader, resources) => {
      for (let i = 1; i <= this.props.framesCount; i++) {
        frames.push(resources['frame' + i].texture)
      }

      this.animation = new PIXI.AnimatedSprite(frames)
      this.animation.x = window.innerWidth
      this.animation.y = this.isMobile
        ? window.innerHeight * 0.75
        : window.innerHeight * 0.5
      this.animation.height = this.isMobile
        ? window.innerWidth * 0.85
        : window.innerWidth * 0.5
      this.animation.width = this.isMobile
        ? window.innerWidth * 0.85
        : window.innerWidth * 0.5
      // this.animation.scale.set(0.35)
      this.animation.anchor.set(1, 0.5)
      this.animation.animationSpeed = 0.065
      this.animation.play()

      this.app.stage.addChild(this.animation)
    })
    this.app.loader.onError.add(error => {
      console.log(error)
    })

    window.addEventListener('resize', this.updateDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions)
  }

  updateDimensions() {
    this.app.renderer.resize(window.innerWidth, window.innerHeight)
    this.animation.height = this.isMobile
      ? window.innerWidth * 0.85
      : window.innerWidth * 0.5
    this.animation.width = this.isMobile
      ? window.innerWidth * 0.85
      : window.innerWidth * 0.5
    this.animation.x = window.innerWidth
  }

  render() {
    return (
      <div
        className='animation-container'
        style={{
          transform: this.props.flip ? 'scale(-1, 1)' : 'none',
          top: this.props.position + 'vh'
        }}
        ref={node => {
          this.pixiContainer = node
        }}
      />
    )
  }
}
